(() => {
  'use strict';

  const ENDPOINT_FALLBACK = 'https://baco-reclamaciones-api.alonzogmg94.workers.dev/api/v1/claims';
  const SCRIPT_ID = 'baco-turnstile-api';
  let turnstileLoader;

  const escapeHtml = (value) => String(value == null ? '' : value)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

  function idempotencyKey() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    const bytes = new Uint8Array(24);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes).map((byte) => byte.toString(16).padStart(2, '0')).join('');
  }

  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (turnstileLoader) return turnstileLoader;
    turnstileLoader = new Promise((resolve, reject) => {
      let script = document.getElementById(SCRIPT_ID);
      if (!script) {
        script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
      script.addEventListener('load', () => window.turnstile ? resolve(window.turnstile) : reject(new Error('No se pudo cargar Turnstile.')), { once: true });
      script.addEventListener('error', () => reject(new Error('No se pudo cargar Turnstile.')), { once: true });
      if (window.turnstile) resolve(window.turnstile);
    });
    return turnstileLoader;
  }

  function receiptRows(receipt) {
    const provider = receipt.provider || {};
    const consumer = receipt.consumer || {};
    const representative = receipt.representative || {};
    const purchase = receipt.purchase || {};
    return [
      ['Proveedor', (provider.legalName || '') + ' — RUC ' + (provider.ruc || '')],
      ['Domicilio del proveedor', provider.address || ''],
      ['Código de registro', receipt.folio || ''],
      ['Fecha y hora de recepción (Lima)', receipt.receivedAt || ''],
      ['Consumidor', consumer.name || ''],
      ['Documento', [consumer.documentType, consumer.documentNumber].filter(Boolean).join(' ')],
      ['Domicilio', [consumer.address, consumer.district].filter(Boolean).join(', ')],
      ['Teléfono', consumer.phone || ''],
      ['Correo', consumer.email || ''],
      ['Representante de menor', representative.isMinor ? [representative.name, representative.documentType, representative.documentNumber, representative.relationship].filter(Boolean).join(' · ') : 'No corresponde'],
      ['Pedido Shopify', purchase.orderNumber || 'No indicado'],
      ['Fecha de compra', purchase.purchaseDate || 'No indicada'],
      ['Producto o servicio', purchase.itemDescription || 'No indicado'],
      ['Monto reclamado', purchase.amount == null ? 'No indicado' : 'S/ ' + Number(purchase.amount).toFixed(2)],
      ['Tipo', receipt.claimType === 'reclamo' ? 'Reclamo' : 'Queja'],
      ['Descripción de los hechos', receipt.description || ''],
      ['Pedido del consumidor', receipt.requestedOutcome || ''],
      ['Observaciones del proveedor', receipt.providerObservations || 'Pendiente de atención']
    ];
  }

  function printReceipt(receipt) {
    const rows = receiptRows(receipt).map(([label, value]) =>
      '<tr><th style="text-align:left;vertical-align:top;padding:8px;border:1px solid #bbb;background:#f3f3f3">' +
      escapeHtml(label) + '</th><td style="vertical-align:top;padding:8px;border:1px solid #bbb;white-space:pre-wrap">' +
      escapeHtml(value) + '</td></tr>').join('');
    const win = window.open('', '_blank');
    if (!win) throw new Error('El navegador bloqueó la ventana de impresión. Permite ventanas emergentes para imprimir la constancia.');
    win.document.open();
    win.document.write('<!doctype html><html lang="es"><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>Constancia ' +
      escapeHtml(receipt.folio) + '</title><body style="font:14px Arial,sans-serif;color:#171717;max-width:820px;margin:24px auto;padding:16px"><h1 style="font-size:22px">Constancia del Libro de Reclamaciones BACO.PE</h1><p>Esta constancia acredita la recepción de la hoja. Su presentación no implica aceptación de responsabilidad ni limita los derechos del consumidor.</p><table style="border-collapse:collapse;width:100%">' +
      rows + '</table><p style="margin-top:18px">Conserva este documento y el folio para consultas.</p><script>window.addEventListener("load",()=>window.print())<\/script></body></html>');
    win.document.close();
  }

  function appendReceipt(form, receipt, emailState) {
    const box = form.querySelector('[data-baco-claims-receipt]');
    const folio = form.querySelector('[data-baco-claims-folio]');
    const email = form.querySelector('[data-baco-claims-email-status]');
    const content = form.querySelector('[data-baco-claims-receipt-content]');
    if (!box || !folio || !email || !content) return;
    folio.textContent = 'Folio: ' + receipt.folio + ' · Fecha y hora (Lima): ' + receipt.receivedAt;
    email.textContent = emailState === 'accepted'
      ? 'Resend aceptó el envío de la constancia al correo registrado. La aceptación no confirma su entrega; revisa tu bandeja de entrada y correo no deseado.'
      : 'La reclamación quedó registrada, pero el correo no fue aceptado por el servicio de envío. Conserva el folio y comunícate con BACO.PE.';
    content.replaceChildren();
    const table = document.createElement('table');
    table.className = 'baco-claims-receipt__table';
    receiptRows(receipt).forEach(([label, value]) => {
      const tr = document.createElement('tr');
      const th = document.createElement('th');
      const td = document.createElement('td');
      th.scope = 'row';
      th.textContent = label;
      td.textContent = value;
      tr.append(th, td);
      table.appendChild(tr);
    });
    content.appendChild(table);
    box.hidden = false;
    box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const print = form.querySelector('[data-baco-claims-print]');
    if (print && !print.dataset.bound) {
      print.dataset.bound = 'true';
      print.addEventListener('click', () => {
        try { printReceipt(receipt); }
        catch (error) { setStatus(form, error.message, 'error'); }
      });
    }
  }

  function setStatus(form, message, type) {
    const status = form.querySelector('[data-baco-claims-status]');
    if (!status) return;
    status.textContent = message;
    status.dataset.state = type || 'info';
    status.hidden = !message;
    if (message) status.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function bindRepresentative(form) {
    const toggle = form.querySelector('[data-baco-minor-toggle]');
    const fields = form.querySelector('[data-baco-representative-fields]');
    if (!toggle || !fields) return;
    const controls = fields.querySelectorAll('input,select');
    const update = () => {
      fields.hidden = !toggle.checked;
      controls.forEach((control) => {
        control.required = toggle.checked;
        if (!toggle.checked) control.value = '';
      });
    };
    toggle.addEventListener('change', update);
    update();
  }

  function formPayload(form, token) {
    const value = (name) => String(new FormData(form).get(name) || '').trim();
    const amountText = value('monto');
    const isMinor = form.querySelector('[name="representante_menor"]')?.checked === true;
    return {
      consumer: {
        name: value('nombre'),
        documentType: value('tipo_documento'),
        documentNumber: value('documento'),
        email: value('email'),
        phone: value('telefono'),
        address: value('direccion'),
        district: value('distrito')
      },
      representative: {
        isMinor,
        name: isMinor ? value('representante_nombre') : '',
        documentType: isMinor ? value('representante_tipo_documento') : '',
        documentNumber: isMinor ? value('representante_documento') : '',
        relationship: isMinor ? value('representante_vinculo') : ''
      },
      orderNumber: value('pedido'),
      purchaseDate: value('fecha'),
      itemDescription: value('producto'),
      amount: amountText === '' ? null : Number(amountText),
      claimType: value('tipo'),
      description: value('detalle'),
      requestedOutcome: value('solucion'),
      turnstileToken: token,
      website: value('website')
    };
  }

  async function initForm(form) {
    if (form.dataset.bacoClaimsInitialized === 'true') return;
    form.dataset.bacoClaimsInitialized = 'true';
    bindRepresentative(form);
    const sitekey = String(form.dataset.bacoClaimsSitekey || '').trim();
    const widget = form.querySelector('[data-baco-turnstile]');
    const submit = form.querySelector('[data-baco-claims-submit]');
    const endpoint = String(form.dataset.bacoClaimsEndpoint || ENDPOINT_FALLBACK);
    let token = '';
    let widgetId = null;
    let lastPayload = '';
    let lastKey = '';
    let submitted = false;

    if (!sitekey) {
      if (submit) submit.disabled = true;
      setStatus(form, 'La protección Turnstile aún no está configurada en los ajustes de esta sección. No envíes datos personales hasta completar esa configuración.', 'error');
      return;
    }
    try {
      const turnstile = await loadTurnstile();
      widgetId = turnstile.render(widget, {
        sitekey,
        action: 'baco_claim',
        callback: (value) => { token = value; setStatus(form, '', 'info'); },
        'expired-callback': () => { token = ''; setStatus(form, 'La verificación venció. Completa Turnstile nuevamente.', 'error'); },
        'error-callback': () => { token = ''; setStatus(form, 'No se pudo validar Turnstile. Recarga la verificación e inténtalo otra vez.', 'error'); }
      });
    } catch (error) {
      if (submit) submit.disabled = true;
      setStatus(form, error.message || 'No se pudo cargar la protección antispam.', 'error');
      return;
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitted || !form.reportValidity()) return;
      if (!token) {
        setStatus(form, 'Completa la verificación de seguridad antes de enviar.', 'error');
        return;
      }
      const button = submit || form.querySelector('[type="submit"]');
      const originalText = button ? button.textContent : '';
      const payload = formPayload(form, token);
      const payloadJson = JSON.stringify(payload);
      if (payloadJson !== lastPayload) {
        lastPayload = payloadJson;
        lastKey = idempotencyKey();
      }
      if (button) { button.disabled = true; button.textContent = 'Enviando…'; }
      setStatus(form, 'Enviando tu reclamación de forma segura…', 'info');
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: {
            'content-type': 'application/json',
            'Idempotency-Key': lastKey,
            'X-Turnstile-Token': token
          },
          body: payloadJson
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || data.ok !== true || !data.folio || !data.receipt) {
          throw new Error(data.error || 'No se pudo registrar la reclamación. Intenta nuevamente.');
        }
        submitted = true;
        if (button) button.textContent = 'Reclamación registrada';
        const duplicate = data.duplicate === true;
        const intro = duplicate
          ? 'El sistema confirmó el registro ya existente de este envío.'
          : 'El sistema confirmó el almacenamiento de tu reclamación.';
        setStatus(form, intro + ' Folio: ' + data.folio + '.', 'success');
        appendReceipt(form, data.receipt, data.receiptEmailState);
        form.querySelectorAll('input,select,textarea,button[type="submit"]').forEach((control) => { control.disabled = true; });
      } catch (error) {
        setStatus(form, error.message || 'No se pudo confirmar el registro. No consideres tu reclamación registrada.', 'error');
        if (button) { button.disabled = false; button.textContent = originalText; }
      } finally {
        token = '';
        try { if (window.turnstile && widgetId !== null) window.turnstile.reset(widgetId); } catch (_) {}
      }
    });
  }

  const init = () => document.querySelectorAll('[data-baco-claims-form][data-baco-claims-remote="true"]').forEach(initForm);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();